import { render, staticRenderFns } from "./TeacherSchoolDetails.vue?vue&type=template&id=0169d0b5&"
import script from "./TeacherSchoolDetails.vue?vue&type=script&lang=js&"
export * from "./TeacherSchoolDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports